export const recoveryRolloutQueryKeys = {
  readiness: (targetMode = 'next') => ['recovery-rollout', 'readiness', targetMode],
  checklist: (checklistType = 'pre', targetMode = 'next') => ['recovery-rollout', 'checklist', checklistType, targetMode],
  blockers: (targetMode = 'V2_PRIMARY_WITH_LEGACY_FALLBACK') => ['recovery-rollout', 'blockers', targetMode],
  rollbackRecommendation: ['recovery-rollout', 'rollback-recommendation'],
  transitionExamples: ['recovery-rollout', 'transition-examples'],
  controlCenterOverview: ['recovery-rollout', 'control-center-overview'],
  controlCenterMismatches: ['recovery-rollout', 'control-center-mismatches'],
  controlCenterPerformance: ['recovery-rollout', 'control-center-performance'],
  shadowSummary: ['recovery-rollout', 'shadow-summary'],
};
